import { render, staticRenderFns } from "./TabellaConsulenti.vue?vue&type=template&id=7621497c&scoped=true"
import script from "./TabellaConsulenti.vue?vue&type=script&lang=js"
export * from "./TabellaConsulenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7621497c",
  null
  
)

export default component.exports